export type HorizontalContentAlign = "start" | "center" | "end";

export function getHorizontalContentAlign(classValue?: string): HorizontalContentAlign | undefined {
  const value = classValue?.trim();

  if (!value || value === "no-class") return undefined;
  if (value.includes("text-start") || value.includes("align-items-start") || value === "me-auto") return "start";
  if (value.includes("text-center") || value.includes("align-items-center") || value === "mx-auto") return "center";
  if (value.includes("text-end") || value.includes("align-items-end") || value === "ms-auto") return "end";

  return undefined;
}

export function getTextAlignClass(align?: HorizontalContentAlign): string {
  return align ? `text-${align}` : "";
}

export function getBlockAlignClass(align?: HorizontalContentAlign): string {
  if (align === "start") return "me-auto";
  if (align === "center") return "mx-auto";
  if (align === "end") return "ms-auto";
  return "";
}

export function getSectionBlockAlignClass(classValue?: string): string {
  const align = getHorizontalContentAlign(classValue);

  if (align === "start") return "align-items-start";
  if (align === "center") return "align-items-center";
  if (align === "end") return "align-items-end";
  return "";
}

export function resolveHorizontalContentAlign(
  explicitClass?: string,
  inheritedAlign?: HorizontalContentAlign,
  fallbackAlign?: HorizontalContentAlign,
): HorizontalContentAlign | undefined {
  return getHorizontalContentAlign(explicitClass) ?? inheritedAlign ?? fallbackAlign;
}